import { ValueOverlayProps } from '../../types';
import { Box } from '@mui/material';

/**
 * Component for displaying current value overlay
 * Feature: Value feedback during painting
 * When: Paint operation is active
 * Then: Show current power value overlay
 */
export function ValueOverlay({ currentValue, mousePosition }: ValueOverlayProps) {
  // If mouse position is provided, position tooltip near cursor
  // Otherwise use default top-right position
  const positionStyle = mousePosition
    ? {
        left: mousePosition.x + 15, // Offset to right of cursor
        top: mousePosition.y - 30, // Offset above cursor
      }
    : {
        top: 10,
        right: 10,
      };

  return (
    <Box
      sx={{
        position: 'absolute',
        ...positionStyle,
        backgroundColor: 'grey.900',
        color: 'common.white',
        padding: '8px 12px',
        borderRadius: 1,
        fontSize: '14px',
        fontWeight: 600,
        zIndex: 1000,
        pointerEvents: 'none',
      }}
    >
      {currentValue.toFixed(1)} kW
    </Box>
  );
}
